import React from 'react'
import PropTypes from 'prop-types'

import createSearchResultBodyContainer from '../../../../shared/containers/searchResultBodyContainer'
import { getConfigBySite } from '../../../../../config/sites'
import ProductList from '../../../components/productList'
import { itemDecorator } from '../../../../../common/utils/item'

class SearchResultBody extends React.Component {
  itemRankOffset() {
    const { currentSite, location } = this.props

    const pageSize = getConfigBySite(currentSite, 'common.search_page_size')

    return ((Number(location.query.page) || 1) - 1) * pageSize + 1
  }

  render() {
    const {
      matches,
      createFavoriteCollection,
      currentSite,
      collections,
      cartItems,
      token,
      deleteBookmark,
      addBookmark,
      favoriteCollectionID,
      openModal,
      location,
      preferences,
      muteVideo,
      isSqueezed
    } = this.props

    return (
      <div data-test-selector="search-results-default">
        <ProductList
          items={matches}
          currentSite={currentSite}
          preferences={preferences}
          muteVideo={muteVideo}
          location={location}
          isSqueezed={isSqueezed}
          itemDecorator={itemDecorator(
            currentSite,
            openModal,
            !token,
            favoriteCollectionID,
            collections,
            deleteBookmark,
            addBookmark,
            createFavoriteCollection,
            this.itemRankOffset(),
            cartItems,
            location
          )}
        />
      </div>
    )
  }
}

SearchResultBody.propTypes = {
  matches: PropTypes.array.isRequired,
  view: PropTypes.string
}

export default createSearchResultBodyContainer(SearchResultBody)
